import { useEffect, useState } from "react";

const getNextSundayMidnight = () => {
  const d = new Date();
  d.setHours(0, 0, 0, 0);
  const day = d.getDay();
  d.setDate(d.getDate() + (day === 0 ? 7 : 7 - day));
  return d;
};

const pad = (n) => String(n).padStart(2, "0");

export const CountdownTimer = () => {
  const [target, setTarget] = useState(getNextSundayMidnight);
  const [now, setNow] = useState(Date.now());

  useEffect(() => {
    const id = setInterval(() => {
      const t = Date.now();
      setNow(t);
      if (target - t <= 0) setTarget(getNextSundayMidnight());
    }, 1000);
    return () => clearInterval(id);
  }, [target]);

  const diff = Math.max(0, target - now);
  const units = [
    ["Days", Math.floor(diff / 86400000)],
    ["Hours", Math.floor(diff / 3600000) % 24],
    ["Minutes", Math.floor(diff / 60000) % 60],
    ["Seconds", Math.floor(diff / 1000) % 60],
  ];

  return (
    <div data-testid="countdown-timer" role="timer" aria-label="Time remaining until this week's free trial offer ends"
      className="flex items-stretch justify-center gap-2.5 sm:gap-4 bg-slate-900 border border-slate-800 rounded-3xl p-5 sm:p-7 text-white shadow-xl max-w-xl mx-auto">
      {units.map(([label, value]) => (
        <div key={label} data-testid={`countdown-${label.toLowerCase()}`} className="flex-1 text-center">
          <div className="bg-slate-800 rounded-2xl py-3 sm:py-4 font-display text-2xl sm:text-4xl font-extrabold tabular-nums text-blue-400">{pad(value)}</div>
          <p className="mt-2 text-[10px] sm:text-xs uppercase tracking-widest font-semibold text-slate-400">{label}</p>
        </div>
      ))}
    </div>
  );
};
